import axios from '@/request';
import qs from 'qs';

export default {
  async list(params: any) {
    return axios.get('precisionmarketing/list', { params });
  },
  async logs(params: any) {
    return axios.get('precisionmarketing/logs', { params });
  },
  async complaints(params: any) {
    return axios.get('precisionmarketing/complaints', { params });
  }
};
